module.exports = __webpack_public_path__ + "media/fonts/SFProText-Regular-d0813481c15d10c318001c55441ecf6b.svg";